<template>
    <div>
        <h2>{{$t('COMMON_SENSE')}}</h2>
        <hr/>
        <div>
            <heading-icon @click="printCommonSense" :title="cgaPatient.firstName + ' ' + cgaPatient.lastName" icon="print" :pointerCursor="true"/>
        </div>
        <hr/>
        <div class="card shadow mb-4">
            <form @submit.prevent="savePatientSheet">
                <div class="card-header py-3 card-header-main">
                    <h6 class="m-0 text-primary">{{$t('HEIGHT')}}: {{cgaPatient.height}}cm</h6>
                </div>
                <b-alert
                    :show="dismissCountDown"
                    dismissible
                    fade
                    :variant="alertType"
                    @dismissed="dismissCountDown = 0">
                    {{alertMessage}}
                </b-alert>
                
                
                <div class="card-body" v-if="activeSheet != null">
                    <div class="row d-flex mx-0 mb-3">
                        <div class="p-0 mb-2 col mr-3">
                            <div class="card-body p-0">
                                <div class="row">
                                    <div class="input-group col-6 row">
                                        <label for="sheet-name" class="col-form-label col-xl-2 col-lg-3">{{$t('NAME')}}</label>
                                        <input id="sheet-name" type="text" v-model="activeSheet.name" @change="changeSheetName($event)" class="form-control col-xl-10 col-lg-9" :placeholder="$t('NAME')" />
                                    </div>
                                    <div class="input-group col-6 row">
                                        <label for="weight" id="inputGroup-sizing-lg" class="col-form-label col-xl-2 col-lg-3">{{$t('WEIGHT')}}</label>                                
                                        <input id="weight" type="text" v-model="activeSheet.weight" @change="changeSheetWeight($event)" class="form-control col-xl-10 col-lg-9" :placeholder="$t('WEIGHT')" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button type="submit" class="btn ml-auto mb-3 h-30">{{$t('SAVE')}}</button>
                    </div>

                    <div class="card shadow mb-2 card-secondary" v-for="(test, index) in activeSheet.tests" :key="index">
                        <div class="card-header card-header-secondary">
                            <h6 class="m-0 text-primary">{{$t(test.testType.title)}}</h6>
                        </div>
                        <div class="card-body inputs-card-body">
                            <div class="row">
                                <div class="form-group row col-6 mb-0 pr-1">
                                    <label :for="'result' + index" class="col-xl-2 col-lg-3 col-form-label col-sm-12">{{ $t('RESULTS') }}</label>
                                    <textarea :id="'result' + index" v-model="test.result" @change="changeSheetTestTypeResult($event, test.id)" class="form-control col-xl-9 col-lg-8"></textarea>
                                </div>
                                <div class="form-group row col-6 mb-0 pl-1">
                                    <label :for="'remark' + index" class=" col-xl-2 col-lg-3 col-form-label">{{ $t('REMARKS') }}</label>
                                    <textarea :id="'remark' + index" v-model="test.remarks" @change="changeSheetTestTypeRemarks($event, test.id)" class="form-control col-xl-8 col-lg-9"></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row d-flex">
                        <button type="submit" class="btn ml-auto mr-3">{{$t('SAVE')}}</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>
<script>
import HeadingIcon from '../misc/HeadingIcon'
    export default {
        components: {
            HeadingIcon
        },
        data () {
            return {
                emptyCgaPatient: {
                    firstName: '',
                    lastName: ''
                },
                saveResponse: {
                    success: null,
                    message: null
                },
                alertType: null,
                dismissCountDown: 0,
                alertMessage: ''
            }
        },
        computed: {
            cgaPatient() {
                return this.$store.getters.cgaPatient || this.emptyCgaPatient;
            },
            activeSheet() {
                if (this.$route.query.sheetId) {
                    return this.$store.getters.cgaSheetById(this.$route.query.sheetId);
                }
                return this.$store.getters.cgaPatientSheet;
            },
        },
        methods: {
            printCommonSense: function() {
                alert('Print');
            },
            savePatientSheet: function() {
                var self = this;
                this.$store.dispatch('commitPatientSheetChanges')
                    .then(response => {
                        self.saveResponse = response.data;
                        console.log(response);
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            changeSheetName: function(event) {
                this.$store.commit('SET_PATIENT_SHEET_NAME', event.target.value);
            },
            changeSheetWeight: function(event) {
                this.$store.commit('SET_PATIENT_SHEET_WEIGHT', event.target.value);
            },
            changeSheetTestTypeResult: function(event, testId) {
                let result = {
                    id: testId,
                    value: event.target.value
                }
                this.$store.commit('SET_PATIENT_SHEET_RESULT', result);
            },
            changeSheetTestTypeRemarks: function(event, testId) {
                let remarks = {
                    id: testId,
                    value: event.target.value
                }
                this.$store.commit('SET_PATIENT_SHEET_REMARKS', remarks);
            }
        },
        watch: {
            saveResponse: function(val)
            {
                if(val.success === true)
                {
                    this.alertMessage = "Changes to Patient Sheet are Successfully Saved";
                    this.alertType = "success";  
                }
                else{
                    this.alertMessage = "Changes to Patient Sheet are Not Successfully Saved";
                    this.alertType = "danger";
                }
                this.dismissCountDown = 3;
            }
        }
    }
</script>
<style lang="scss" scoped>
    .inputs-card-body {
        padding: 10px;
    }

    .h-30 {
        height: 30px !important;
    }
    .card-header-secondary {
        background-color: white;
        h6 {
            color: #858796 !important;
        }
    }
</style>